import { render, staticRenderFns } from "./datasource-object.vue?vue&type=template&id=55e81356&scoped=true&"
import script from "./datasource-object.vue?vue&type=script&lang=ts&"
export * from "./datasource-object.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e81356",
  null
  
)

export default component.exports